import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";
const { blue, carbon } = colorsPalettes;

export const SortWrapper = styled(FlexRow)<{ isDisabled?: boolean }>`
    position: relative;
    justify-content: flex-end;
    min-width: 225px;

    & > div {
        width: auto !important;
    }

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;
            opacity: 0.3;
        `}

    .isSelected {
        .CustomStyledFilter {
            background-color: rgba(77, 135, 247, 0.2);
            .ChipItemText {
                color: ${blue[500]};
            }
        }
    }
`;

export const SortIcon = styled(SWReactIcons)`
    display: flex;
    width: 20px;

    path {
        fill: ${carbon[500]} !important;
    }
`;

export const Text = styled.div`
    ${setFontVariant("button", carbon[500])}
`;
